import React from 'react';
import { Text } from '@instructure/ui-text';
import { Flex } from '@instructure/ui-flex';
import { IconButton } from '@instructure/ui-buttons';
import { IconMoreLine } from '@instructure/ui-icons';
import { Menu } from '@instructure/ui-menu';
import { View } from '@instructure/ui-view';
import { AccessibleContent } from '@instructure/ui-a11y-content';
import { TruncateText } from '@instructure/ui-truncate-text';
import { CELL_HEIGHT, COLUMN_WIDTH } from "../../../../util/gradebook/constants.js";
import TruncateWithTooltip from "../../shared/TruncateWithTooltip/index.js";
import { getInverseColor } from "../../../../util/gradebook/colors.js";
export var ColumnHeader = function ColumnHeader(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    optionsMenuTriggerLabel = _ref.optionsMenuTriggerLabel,
    optionsMenu = _ref.optionsMenu,
    _ref$optionsMenuItems = _ref.optionsMenuItems,
    optionsMenuItems = _ref$optionsMenuItems === void 0 ? [] : _ref$optionsMenuItems,
    icon = _ref.icon,
    _ref$background = _ref.background,
    background = _ref$background === void 0 ? 'secondary' : _ref$background,
    _ref$columnWidth = _ref.columnWidth,
    columnWidth = _ref$columnWidth === void 0 ? COLUMN_WIDTH : _ref$columnWidth,
    _ref$showTruncatedToo = _ref.showTruncatedTooltip,
    showTruncatedTooltip = _ref$showTruncatedToo === void 0 ? true : _ref$showTruncatedToo;
  return /*#__PURE__*/React.createElement(View, {
    background: background,
    as: "div",
    width: columnWidth,
    "data-testid": "column-header"
  }, /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    justifyItems: "space-between",
    height: CELL_HEIGHT,
    padding: "none x-small none x-small"
  }, /*#__PURE__*/React.createElement(Flex.Item, {
    shouldGrow: true,
    shouldShrink: true,
    overflowX: "hidden"
  }, /*#__PURE__*/React.createElement(Flex, {
    gap: "x-small"
  }, icon && /*#__PURE__*/React.createElement(Flex.Item, {
    padding: "0 0 xx-small none"
  }, icon), /*#__PURE__*/React.createElement(Flex.Item, {
    shouldGrow: true,
    shouldShrink: true,
    overflowX: "hidden",
    padding: "0 xx-small 0 0"
  }, /*#__PURE__*/React.createElement(AccessibleContent, {
    alt: title,
    id: titleId
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "bold"
  }, showTruncatedTooltip ? /*#__PURE__*/React.createElement(TruncateWithTooltip, null, title) : /*#__PURE__*/React.createElement(TruncateText, null, title)))))), optionsMenuItems.length > 0 && /*#__PURE__*/React.createElement(Menu, {
    placement: "bottom",
    trigger: /*#__PURE__*/React.createElement(IconButton, {
      withBorder: false,
      withBackground: false,
      size: "small",
      screenReaderLabel: optionsMenuTriggerLabel,
      color: getInverseColor(background)
    }, /*#__PURE__*/React.createElement(IconMoreLine, null))
  }, optionsMenuItems), optionsMenu));
};